module.exports = __webpack_public_path__ + "static/media/30.4915a365.jpg";